export class SessionCoordinatorMessage {
  public type: SessionCoordinatorMessageType;
  public value?: SessionCoordinatorResponseValue;

  public constructor(type: SessionCoordinatorMessageType, value?: SessionCoordinatorResponseValue) {
    this.type = type;
    this.value = value;
  }
}

export enum SessionCoordinatorMessageType {
  QUERY_TABS = 'SessionCoordinator:QueryTabs',
  RESPONSE = 'SessionCoordinator:Response',
  SHOW_MODAL = 'SessionCoordinator:ShowModal',
  RESET = 'SessionCoordinator:Reset',
}

export enum SessionCoordinatorResponseValue {
  ACTIVE = 'SessionCoordinator:Active',
  IDLE = 'SessionCoordinator:Idle',
}
